<template>
  <section>
    <form action="" v-on:submit.prevent="createUser">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Crear Usuario</p>
        </header>
        <section class="modal-card-body">
          <b-tabs>
            <b-tab-item label="Datos del Usuario">
              <b-field label="Nombre">
                <b-input
                  type="text"
                  :value="user.name"
                  v-model="user.name"
                  placeholder="Nombre"
                  required
                ></b-input>
              </b-field>
              <b-field label="Apellido Paterno">
                <b-input
                  type="text"
                  :value="user.apepat"
                  v-model="user.apepat"
                  placeholder="Apellido Paterno"
                  required
                ></b-input>
              </b-field>
              <b-field label="Apellido Materno">
                <b-input
                  type="text"
                  :value="user.apemat"
                  v-model="user.apemat"
                  placeholder="Apellido Materno"
                  required
                ></b-input>
              </b-field>
              <b-field label="Rut">
                <b-input
                  type="text"
                  :value="user.rut"
                  v-model="user.rut"
                  placeholder="RUT"
                  required
                ></b-input>
              </b-field>
              <b-field label="Email">
                <b-input
                  type="email"
                  :value="user.email"
                  v-model="user.email"
                  placeholder="Your email"
                  required
                ></b-input>
              </b-field>
              <b-field label="Password">
                <b-input
                  type="password"
                  :value="user.password"
                  v-model="user.password"
                  password-reveal
                  placeholder="Password"
                  required
                ></b-input>
              </b-field>
              <b-field label="Perfil">
                <b-select
                  required
                  v-model="user.role_id"
                  placeholder="Seleccione un perfil"
                  expanded
                >
                  <option
                    v-for="role in roles"
                    :value="role.id"
                    :key="role.id"
                  >
                    {{ role.type }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Establecimiento">
                <b-select
                  required
                  v-model="user.stablishment_id"
                  placeholder="Seleccione un establecimiento"
                  expanded
                >
                  <option
                    v-for="stablishment in stablishments"
                    :value="stablishment.id"
                    :key="stablishment.id"
                  >
                    {{ stablishment.name }}
                  </option>
                </b-select>
              </b-field>
            </b-tab-item>
          </b-tabs>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">
            Guardar
          </button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import { GetAllStablishment } from "../../../services/stablishment";
import { GetRoleAll } from "../../../services/role";

export default {
  props: ["loadUsers"],
  data() {
    return {
      roles: [],
      user: {
        name: "",
        apepat: "",
        apemat: "",
        rut: "",
        email: "",
        password: "",
        perfil_id: null,
      },
      stablishments: [],
      isLoading: false,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      this.stablishments = await GetAllStablishment(this.$http);
      this.roles = await GetRoleAll(this.$http);
      this.isLoading = false;
    },
    createUser: async function () {
      let loader = this.$buefy.loading.open();
      await this.$http.post(
        `api/${localStorage.getItem("perfil")}/user`,
        this.user
      );
      loader.close();
      this.loadUsers();
      this.$parent.close();
      this.toast("El usuario se ha creado exitosamente", "is-success");
    },
  },
};
</script>